<template>
<section class="section-home-hero-promo" v-bind="sectionAttributes" :class="sectionHighlightClasses">
  <div class="static-container">
    <h1 v-if="promo.heading" class="promo-header" v-html="promo.heading"></h1>
    <h2 v-if="promo.subheading" class="promo-subtitile" v-html="promo.subheading"></h2>
    <template v-if="promo.promo_button_visibility === 'always'">
      <div class="promo-separator"></div>
      <div class="promo-actions-wrapper">
        <router-link :to="promoButtonRouteParams" class="btn btn-secondary btn-large">
          {{ promo.promo_button }}
        </router-link>
      </div>
    </template>
  </div>
</section>
</template>

<script>
import HasSectionHighlights from '@/mixins/HasSectionHighlights'

export default {
  props: ['promo'],

  mixins: [HasSectionHighlights],

  computed: {
    promoButtonRouteParams() {
      return {
        name: 'catalog',
      }
    },

    sectionAttributes() {
      let attributes = {}
      attributes.style = {}

      if (this.promo.background) {
        attributes.style['background-image'] = this.backgroundStyle
      }

      return attributes
    },

    backgroundStyle() {
      return `linear-gradient(rgba(0, 0, 0, 0.12), rgba(0, 0, 0, 0.12)), url(${this.promo.background})`
    },
  },

  methods: {
    getSectionNamespace() {
      return 'home_promo'
    }
  },
}
</script>

<style lang="less">
@tailwind components;

.section-home-hero-promo {
  @apply flex flex-wrap flex-col items-center justify-center relative px-2 pb-16;
  padding-top: calc(var(--header-height) + 3rem);
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top;

  .promo-header {
    @apply text-white font-light text-2xl leading-tight mb-6 text-center;
  }

  .promo-subtitile {
    @apply text-white font-light text-lg text-center;
  }

  .promo-separator {
    @apply my-8 bg-white mx-auto;
    height: 1px;
    width: 60px;

    &::after {
      content: "";
      display: table;
      clear: both;
    }
  }

  .promo-actions-wrapper {
    @apply text-center;
    .btn {
      @apply font-light btn-rounded-sm;
    }
  }
}

@screen lg {
  .section-home-hero-promo {
    .promo-header {
      @apply text-5xl;
    }

    .promo-subtitile {
      @apply text-2xl;
    }
  }
}
</style>
